import QRCode from "react-qr-code";
import { qrValue } from "../../../../../shared/qrCode/utils/qrValue";
import { InstrumentInterface } from "../types/instrumentTypes";

export const InstrumentQRCode = ({ instrument }: { instrument: InstrumentInterface }) => {
  return <QRCode value={qrValue(instrument.tag)} size={150} />;
};
